import { useState, useEffect, useRef } from "react";
import { Edit, ListCheck, CalendarDays, Gift, Image } from "lucide-react";

import useDocumentTitle from '../../hooks/useDocumentTitle';
import ShimmerLoader from '../../hooks/ShimmerLoader';
import { creatLoyalityReward, getLoyaltyRewards, getLoyaltyProgram, fetchstores } from "../../services/api";
import Pagination from "../../hooks/Pagination";

import toastr from 'toastr';

import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";
import dayjs from "dayjs";

import { DateInput } from "@mantine/dates";

export default function LoyaltyRewards() {
  useDocumentTitle('Welcome to Admin | Loyalty Card');
  const [loyalty_card, setLoyaltyCard] = useState([]);
  const [loyalty_program, setLoyaltyProgram] = useState([]);
  const [storelist, setStoreList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fileInputRef = useRef(null);
  const wrapperRef = useRef(null);
  const [suggestions, setSuggestions] = useState([]);


  const perPage = 20;
  const fetchLoyaltyCard = async (perPage, currentPage) => {
    try {
      const response = await getLoyaltyRewards(perPage, currentPage);
      const data = await response.data;
      setLoyaltyCard(data.data || data); // Adjust based on your API response structure
      setCurrentPage(data.current_page);
      setTotalPages(data.last_page);
    } catch (err) {
      setError(err.message || 'Failed to fetch Loyalty Card');
    } finally {
      setLoading(false);
    }
  };

  const fetchStore = async (keyword = '') => {
    try {
      const response = await fetchstores(25, 1, keyword);
      const data = await response.data;
      if (keyword.length > 2) {
        setSuggestions(data.data || data);
      } else {
        setStoreList(data.data || data);
      }

    } catch (err) {
      setError(err.message || 'Failed to store');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const fetchLoyaltyProgram = async () => {
      try {
        const response = await getLoyaltyProgram();
        const data = await response.data;
        setLoyaltyProgram(data.data || data);
      } catch (err) {
        setError(err.message || 'Failed to fetch Loyalty program');
      } finally {
        setLoading(false);
      }
    };
    fetchLoyaltyProgram()
    fetchStore()
    fetchLoyaltyCard(perPage, currentPage);
  }, [currentPage]);
  const initialFormData = {
    stores_id: [],
    reward_id: 0,
    program_id: "",
    is_active: "1",
    reward_name: '',
    description: "",
    start_date: null,
    points_required: "0",
    end_date: null,
    reward_logo: null,
    dealtype: 0,
    rewardtype: 0,
    dealvalue: 0,
    ownervalue: 0,
    custvalue: 0,
    ordervalue: 0,
    rewardvalue: 0,
  };
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const handleOpen = () => {
    setOpen(!open)
    setSelected([]);
    setFormData(initialFormData)
  };

  const handleChange = (e, field = '') => {
    let name = '';
    let value = '';
    if (e.target) {
      name = e.target.name;
      value = e.target.value;
    } else {
      name = field;//field.name;
      value = e;//.toLocaleString("sv-SE")//toISOString()
    }


    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleChangeImg = (e, field = '') => {
    const { name, type, files } = e.target;
    if (type === "file" && files.length > 0) {
      const file = files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({
          ...prev,
          [name]: file, // actual file
          [`${name}_preview`]: reader.result, // preview URL
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataToSend = new FormData();
    toastr.options = {
      closeButton: true,
      progressBar: true,
      timeOut: 3000,
      positionClass: 'toast-top-center'
    };

    if (selected.length === 0) {
      toastr.error('Select at least one store Name', { timeOut: 2000 });
      return false
    }
    if (formData.program_id === '') {
      toastr.error('Select Program Name', { timeOut: 2000 });
      return false
    }
    if (formData.reward_name === '') {
      toastr.error('Enter reward number', { timeOut: 2000 });
      return false
    }
    if (formData.description === '') {
      toastr.error('Enter description', { timeOut: 2000 });
      return false
    }

    // console.log(formData);
    // return false;


    // for (let key in formData) {
    //   formDataToSend.append(key, formData[key]);
    // }
    Object.entries(formData).forEach(([key, value]) => {
      formDataToSend.append(key, value);
    });

    try {
      const response = await creatLoyalityReward(formDataToSend);
      if (response.status.success) {
        fetchLoyaltyCard(perPage, currentPage);
        setOpen(false)
        toastr.success(response.message)
        setFormData(initialFormData);

      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      // console.error("Error:", error);
      toastr.error("Add Reward failed. Please try again.");
    }
  }

  const handleEdit = ((item) => {
    setSelected(handleToarray(item.store_info));
    let store = (handleToarray(item.store_info));

    setFormData({
      stores_id: JSON.stringify(store),
      reward_id: item.reward_id,
      program_id: item.program_id,
      is_active: item.is_active,
      reward_name: item.reward_name,
      description: item.description,
      start_date: (item.start_date) ? dayjs(item.start_date).format("YYYY-MM-DD") : null,
      end_date: (item.end_date) ? dayjs(item.end_date).format("YYYY-MM-DD") : null,
      points_required: item.points_required,
      reward_logo: item.reward_logo,
      dealtype: item.dealtype,
      rewardtype: item.rewardtype,
      dealvalue: item.dealvalue,
      ownervalue: item.ownervalue,
      custvalue: item.custvalue,
      ordervalue: item.ordervalue,
      rewardvalue: item.rewardvalue,
    });
    setOpen(true)
  })

  const handleToarray = ((storeString) => {
    const storeArray = storeString.split(',').map(item => {
      const [id, name] = item.trim().split(':');
      return {
        id: parseInt(id),
        store_name: name.trim()
      };
    });
    return storeArray
  })

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsFocused(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [storeOptions, setStoreOptions] = useState([]);

  const filteredOptions = storeOptions.filter(
    (store) =>
      store.store_name.toLowerCase().includes(search.toLowerCase()) &&
      !selected.find((s) => s.id === store.id)
  );


  useEffect(() => {
    const fetchOnNoMatch = async () => {
      if (search.trim() && filteredOptions.length === 0 && !loading) {
        fetchStore(search)
        setTimeout(function () {
          setStoreOptions(storelist);
        }, 500);
      } else {
        setStoreOptions(storelist);
      }
    };
    fetchOnNoMatch();
  }, [search, isFocused]);

  const addStore = (store) => {
    const selectedStore = {
      id: store.id,
      store_name: store.store_name,
    };
    const newSet = [...selected, selectedStore]
    setSelected(newSet);
    setFormData(prev => ({
      ...prev,
      ['stores_id']: JSON.stringify(newSet)
    }));
    setSearch("");
  };

  const removeStore = (id) => {
    const newSet = selected.filter((store) => store.id !== id)
    setSelected(newSet);
    setFormData(prev => ({
      ...prev,
      ['stores_id']: JSON.stringify(newSet)
    }));
  };

  return (
    <div className="flex flex-col md:flex-row gap-4 md:gap-4">

      {open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <form onSubmit={handleSubmit}>
            <div className="bg-white rounded-lg shadow-xl min-w-[300px] w-[60vw] max-w-[900px] max-h-[95vh] flex flex-col">
              <div className="flex justify-between items-center border-b px-6 py-4">
                <h3 className="text-lg font-semibold">Add Loyalty Reward</h3>
                <button
                  type="button"
                  onClick={() => setOpen(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div className="p-4 space-y-4 overflow-y-auto flex-grow">
                <div ref={wrapperRef} className="grid grid-cols-1 md:grid-cols-1 gap-4">
                  <div className="border border-gray-300 rounded-md p-2 min-h-[48px] flex flex-wrap gap-1"
                  // onClick={() => document.getElementById("store-input").focus()}
                  >
                    {selected.map((store, key) => (
                      <span
                        key={store.id + '-' + key}
                        className="bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-sm flex items-center"
                      >
                        {store.store_name}
                        <button
                          onClick={() => removeStore(store.id)}
                          className="ml-1 text-blue-500 hover:text-blue-700"
                        >
                          &times;
                        </button>
                      </span>
                    ))}

                    <input
                      id="store-input"
                      type="text"
                      className="flex-grow outline-none p-1 text-sm"
                      placeholder="Search by store/events name, email or mobile..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      onFocus={() => setIsFocused(true)}
                    // onBlur={() => setTimeout(() => setIsFocused(false), 150)} // small delay to allow click
                    />
                  </div>

                  {isFocused && filteredOptions.length > 0 && (
                    <ul className="border border-gray-300 rounded-md max-h-60 overflow-y-auto bg-white shadow">
                      {filteredOptions.map((store) => (
                        <li
                          key={store.id}
                          className="px-3 z-10 py-2 hover:bg-blue-100 cursor-pointer text-sm"
                          onClick={() => addStore(store)}
                        >
                          {store.store_name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                {/* <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-1">Store List</label>
                    <div className="relative">
                      <div className="relative w-full" ref={wrapperRef}>
                        <div className="relative">
                          <input
                            id="search"
                            type="text"
                            value={query}
                            onChange={handleInputChange}
                            onFocus={handleInputChange}
                            className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                            placeholder="Search by store name, email or mobile..."
                            autoComplete="off"
                          />
                          <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                          {query && (
                            <button
                              onClick={clearSelection}
                              className="absolute right-2 top-2 text-gray-400 hover:text-gray-600"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                              </svg>
                            </button>
                          )}
                        </div>
                        {showSuggestions && suggestions.length > 0 && (
                          <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                            <ul>
                              {suggestions.map((item) => (
                                <li
                                  key={item.id}
                                  onClick={() => handleSuggestionClick(item)}
                                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-b-0"
                                >
                                  <div className="font-medium">{item.store_name}</div>
                                  <div className="text-sm text-gray-500">{item.address} | {item.type}</div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div> */}

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-1">Program Name</label>
                    <div className="relative">
                      <select name="program_id" value={formData.program_id || ""} onChange={handleChange} className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      >
                        <option value="" disabled>Select</option>
                        {loyalty_program.map((item) => (
                          <option key={item.program_id + 111} value={item.program_id}>{item.program_name}</option>
                        ))}
                      </select>
                      <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">Reward Name </label>
                    <div className="relative">
                      <input
                        type="text"
                        name="reward_name"
                        value={formData.reward_name || ""}
                        onChange={handleChange}
                        placeholder="Reward Name"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />
                      <Gift className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-1">Points Required</label>
                    <div className="relative">
                      <input
                        type="text"
                        name="points_required"
                        value={formData.points_required || ""}
                        onChange={handleChange}
                        placeholder="0"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />
                      <Gift className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-1">Status</label>
                    <div className="relative">
                      <select name="is_active" value={formData.is_active || ""} onChange={handleChange} className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      >
                        <option value="" disabled>Select</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                      <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>


                </div>

                <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-1">Description </label>
                    <div className="relative">
                      <textarea
                        type="text"
                        name="description"
                        value={formData.description || ""}
                        onChange={handleChange}
                        placeholder="Description"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />
                      <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-1">Start Date </label>
                    <div className="relative">
                      <DateInput
                        valueFormat="DD-MM-YYYY"
                        placeholder="Pick start date"
                        value={formData.start_date}
                        onChange={(date) => {
                          handleChange(date, 'start_date');
                          // reset toDate if it's before the new fromDate
                          if (formData.end_date && date && formData.end_date < date) {
                            handleChange(null, 'end_date');//setToDate(null);
                          }
                        }}
                        leftSection={<CalendarDays size={18} className="text-gray-400" />}
                        className="w-full rounded-xl"
                      />
                      {/* <DatePicker
                        autoComplete="off"
                        placeholderText="Select a Start date"
                        selected={formData.start_date}
                        dateFormat="dd/MM/yyyy"
                        name='start_date' id='start_date'
                        onChange={(e) => handleChange(e, 'start_date')}
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                        style={{ padding: '5px' }}
                      /> */}

                      {/* <Flatpickr
                        value={formData.start_date}
                        onChange={([date]) => {
                          handleChange(date, 'start_date')
                          if (formData.start_date && formData.end_date && formData.end_date < formData.start_date) {
                            handleChange(date, 'end_date')
                          }
                        }}
                        // onChange={([date]) => handleChange(date, 'start_date')}
                        options={{
                          // minDate: 'today',
                          enableTime: false,
                          time_24hr: true,
                          defaultDate: null,
                          altFormat: 'Y-m-d',
                          dateFormat: "d/m/Y", // Format: DD/MM/YYYY
                        }}
                        placeholder="Select a Start date"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      /> */}

                      {/* <CalendarDays className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} /> */}
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">End Date</label>
                    <div className="relative">
                      <DateInput
                        valueFormat="DD-MM-YYYY"
                        minDate={formData.start_date || undefined}
                        placeholder="Pick End date"
                        value={formData.end_date}
                        onChange={(date) => {
                          handleChange(date, 'end_date');
                        }}
                        leftSection={<CalendarDays size={18} className="text-gray-400" />}
                        className="w-full rounded-xl"
                      />
                      {/* <Flatpickr
                        value={formData.end_date}
                        onChange={([e]) => handleChange(e, 'end_date')}
                        options={{
                          enableTime: false,
                          time_24hr: true,
                          defaultDate: null,
                          altFormat: 'Y-m-d',
                          dateFormat: "d/m/Y", // Format: DD/MM/YYYY
                        }}
                        placeholder="Select a End date"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      /> */}
                      {/* <DatePicker
                        autoComplete="off"
                        placeholderText="Select a End date"
                        selected={formData.end_date}
                        minDate={formData.issue_date}
                        dateFormat="dd/MM/yyyy"
                        name='end_date' id='end_date'
                        onChange={(e) => handleChange(e, 'end_date')}
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                        style={{ padding: '5px' }}
                      /> */}
                      {/* <CalendarDays className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} /> */}
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2">Deals In</label>
                    <div className=" gap-6">
                      {["0", "1"].map((type) => (
                        <label key={type} className="inline-flex items-center gap-2">
                          <input
                            type="radio"
                            name="dealtype"
                            value={type}
                            checked={formData.dealtype == type}
                            onChange={handleChange}
                          // className="accent-[#f4a406]"
                          />
                          <span className="text-sm font-medium">
                            {type === "0" ? "Percentage" : "Fixed"}
                          </span>&nbsp;
                        </label>
                      ))}
                      <div className=" gap-6">
                        <label className="block text-sm font-medium mb-2">Total value</label>
                        <input
                          type="number"
                          name="dealvalue"
                          value={formData.dealvalue || ""}
                          onChange={handleChange}
                          placeholder="Total value"
                          className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                        />
                      </div>
                      <div className=" gap-6">
                        <label className="block text-sm font-medium mb-2">Value for customer</label>
                        <input
                          type="number"
                          name="custvalue"
                          value={formData.custvalue || ""}
                          onChange={handleChange}
                          placeholder="value for customer"
                          className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                        />
                      </div>
                      <div className=" gap-6">
                        <label className="block text-sm font-medium mb-2">Value for owner</label>
                        <input
                          type="number"
                          name="ownervalue"
                          value={formData.ownervalue || ""}
                          onChange={handleChange}
                          placeholder="value owner"
                          className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2">Reward formula</label>
                    <div className=" gap-6">

                      <div className=" gap-6">
                        <label className="block text-sm font-medium mb-2">Min. Order value</label>
                        <input
                          type="number"
                          name="ordervalue"
                          value={formData.ordervalue || ""}
                          onChange={handleChange}
                          placeholder="Minimum Order value"
                          className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                        />
                      </div>
                      {["0", "1"].map((type) => (
                        <label key={type} className="inline-flex items-center gap-2">
                          <input
                            type="radio"
                            name="rewardtype"
                            value={type}
                            checked={formData.rewardtype == type}
                            onChange={handleChange}
                          // className="accent-[#f4a406]"
                          />
                          <span className="text-sm font-medium">
                            {type === "0" ? "Percentage" : "Fixed"}
                          </span>&nbsp;
                        </label>
                      ))}
                      <div className=" gap-6">
                        <label className="block text-sm font-medium mb-2">Get Reward value</label>
                        <input
                          type="number"
                          name="rewardvalue"
                          value={formData.rewardvalue || ""}
                          onChange={handleChange}
                          placeholder="Enter value % OR Fixed"
                          className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-1">Reward Image</label>
                    <div className="flex items-center gap-4">
                      <div className="relative flex-1">
                        <input
                          type="file"
                          ref={fileInputRef}
                          name="reward_logo"
                          accept="image/*"
                          onChange={handleChangeImg}
                          className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406] file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-[#f4a406] file:text-white hover:file:bg-yellow-600"
                        />
                        <Image className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-1">Preview Image</label>
                    <div className="flex items-center gap-4">
                      <div className="relative flex-1">
                        {formData.reward_logo && (
                          <div className="w-full border rounded-xl overflow-hidden">
                            <img
                              src={
                                typeof formData.reward_logo === 'string'
                                  ? `${formData.reward_logo}`
                                  : formData.reward_logo_preview
                              }
                              alt="Uploaded Preview"
                              className="w-full h-full object-cover"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div className="flex justify-end border-t px-6 py-4">
                <button
                  type="submit"
                  className="w-full bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      )}

      <div className="w-full  bg-white shadow-lg rounded-2xl p-6">

        <div className="grid grid-flow-col grid-rows-3 gap-4">
          <div className="row-start-1 row-end-4"><h2 className="text-2xl font-bold mb-4">Loyalty Reward</h2></div>
          <div className="row-start-1 row-end-4 text-right">
            <button type="button" onClick={handleOpen} className="py-2 px-4  bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors">Add New</button>
          </div>
        </div>
        <div className="overflow-auto">

          <table className="w-full text-sm text-left">
            <thead className="text-gray-700 bg-gray-100">
              <tr>
                <th className="p-3">ID</th>
                <th className="p-3">Program Name</th>
                <th className="p-3">Reward name</th>
                <th className="p-3">Description</th>
                <th className="p-3">Points Required</th>
                <th className="p-3">Created On</th>
                <th className="p-3 text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {loading ? (
                <>
                  <tr>
                    <td className="p-3" colSpan={7}>
                      <ShimmerLoader />
                      <ShimmerLoader />
                      <ShimmerLoader />
                    </td>
                  </tr>
                </>
              ) : (
                <>
                  {loyalty_card.length > 0 ? (
                    loyalty_card.map((item, key) => (
                      <tr key={key}>
                        <td className="p-3">{item.reward_id}</td>
                        <td className="p-3">{item.program_name}</td>
                        <td className="p-3">{item.reward_name}</td>
                        <td className="p-3">{item.description}</td>
                        <td className="p-3">{item.points_required}</td>
                        <td className="p-3">{item.createdDate}</td>
                        <td className="p-3 text-center space-x-2">
                          <button onClick={() => handleEdit(item)} className="text-[#f4a406] hover:underline inline-flex items-center gap-1">
                            <Edit size={16} />
                          </button>
                          {/* <button className="text-red-500 hover:underline inline-flex items-center gap-1">
                            <Trash2 size={16} />
                          </button> */}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="p-3" colSpan={7}>
                        No record found
                      </td>
                    </tr>
                  )}

                </>
              )}

            </tbody>
          </table>
          <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
        </div>
      </div>
    </div>
  );
}
